import React, { FocusEvent, useContext } from "react";
import { Field, ReduxFormContext } from "redux-form";
import { DateInputField, TextField } from "capitalrx-components";
import { formValidation } from "capitalrx-utilities";
import MainFormSection from "@/App/components/MainFormSection";
import { GeneralTypes } from "@/types";

interface Props {
  handleFieldOnBlur: GeneralTypes.EventWithDataHandler<FocusEvent<object>>;
}

const GeneralClaimInformation: React.FC<Props> = (props: Props) => {
  const { required } = formValidation;
  const { handleFieldOnBlur } = props;

  const drugFormContents = useContext(ReduxFormContext);
  const directMemberReimbursementIndicator = drugFormContents.getValues().direct_member_reimbursement_indicator;

  return (
    <MainFormSection showRequire removeSectionTitle>
      <div className="row">
        <div className="col-4">
          <Field component={TextField} id="notes" data-testid="notes" label="Reference ID" name="notes" onBlur={handleFieldOnBlur} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            component={DateInputField}
            id="date-of-service"
            data-testid="date_of_service"
            label="Date of Service"
            name="date_of_service"
            validate={[required]}
            showRequiredStar
            onBlur={handleFieldOnBlur}
          />
        </div>
        <div className="col">
          <Field
            component={DateInputField}
            id="claim-submission-date"
            data-testid="claim-submission-date"
            label="Claim Submission Date"
            name="claim_submission_date"
            validate={[required]}
            showRequiredStar
            onBlur={handleFieldOnBlur}
          />
        </div>
        {directMemberReimbursementIndicator !== "5" && (
          <div className="col">
            <Field
              component={TextField}
              id="prescription-service-reference-number"
              data-testid="prescription_service_reference_number"
              label="Prescription Service Reference Number"
              name="prescription_service_reference_number"
              onBlur={handleFieldOnBlur}
            />
          </div>
        )}
      </div>
    </MainFormSection>
  );
};

export default GeneralClaimInformation;
